import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool, shape } from "prop-types";
import { push } from "connected-react-router";

import { selectors as investmentfundsSelectors, actions as investmentfundsActions } from "reducers/investmentfunds";

import Col from "react-bootstrap/lib/Col";
import { Field, Form, Formik } from "formik";
import PageLoading from "pages/_components/PageLoading";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import MainContainer from "pages/_components/MainContainer";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Checkbox from "pages/_components/Checkbox";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";

const FORM_ID = "investmentFunds.add.account.ddjj";

class SwornDeclaration extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        accountData: shape({}).isRequired,
    };

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }

    componentDidMount() {
        const { accountData } = this.props;
        const { current } = this.formRef;

        if (accountData && current != null) {
            current.setFieldValue("ddjjYes", accountData.ddjj === "SI");
            current.setFieldValue("ddjjNo", accountData.ddjj === "NO");
        }
    }

    handleCheckboxChange = (fieldName) => {
        const { current } = this.formRef;

        current.setFieldValue("ddjjYes", fieldName === "ddjjYes");
        current.setFieldValue("ddjjNo", fieldName === "ddjjNo");
    };

    handleSubmit = (values) => {
        const { dispatch, accountData } = this.props;
        const accountDataUpdate = {
            ...accountData,
            ddjj: values.ddjjYes ? "SI" : "NO",
        };

        dispatch(investmentfundsActions.setAccountData(accountDataUpdate));
        dispatch(push("/investmentFunds/accounts/add/confirm"));
    };

    render() {
        const { fetching, accountData } = this.props;

        return (
            <PageLoading loading={fetching}>
                <Notification scopeToShow="investmentfunds" />
                <CustomProductHead
                    titleId="investmentFunds.add.account.ddjj.title"
                    className="new-deposit-request"
                    backLinkTo="/investmentFunds/accounts/add">
                    <div className="toolbar-item view-title">
                        <ViewTitle id="investmentFunds.add.account.ddjj.title" />
                    </div>
                </CustomProductHead>

                <MainContainer className="main-container">
                    <Formik onSubmit={this.handleSubmit} ref={this.formRef}>
                        {({ values }) => {
                            const disabled = !values.ddjjYes && !values.ddjjNo;

                            return (
                                <Form className="above-the-fold">
                                    <Grid className="form-content">
                                        <Row className="justify-content-center">
                                            <div className="illustration text-justify">
                                                <Col xs={12} md={10} mdOffset={1}>
                                                    <I18n
                                                        id="investmentFunds.add.account.ddjj.subTitle"
                                                        component="h3"
                                                    />
                                                    <I18n id="investmentFunds.add.account.ddjj.text1" />
                                                </Col>
                                            </div>
                                        </Row>
                                        <div className="pb-6" />
                                        <Row className="justify-content-center">
                                            <div className="illustration text-justify">
                                                <Col xs={12} md={10} mdOffset={1}>
                                                    <Field
                                                        component={Checkbox}
                                                        idForm={FORM_ID}
                                                        name="ddjjYes"
                                                        onChange={() => this.handleCheckboxChange("ddjjYes")}
                                                        labelClassName="concepts-checkbox"
                                                        labelText="investmentFunds.add.account.ddjj.yes"
                                                        value={accountData?.ddjj === "SI"}
                                                    />
                                                    <div className="pb-6" />
                                                    <Field
                                                        component={Checkbox}
                                                        idForm={FORM_ID}
                                                        name="ddjjNo"
                                                        onChange={() => this.handleCheckboxChange("ddjjNo")}
                                                        labelClassName="concepts-checkbox"
                                                        labelText="investmentFunds.add.account.ddjj.no"
                                                        value={accountData?.ddjj === "NO"}
                                                    />

                                                    <div className="pb-6" />
                                                    <I18n id="investmentFunds.add.account.ddjj.text2" />
                                                </Col>
                                            </div>
                                        </Row>

                                        <Row className="form-actions">
                                            <Col xs={12} md={4} mdOffset={4}>
                                                <div className="toolbar-item add-button" key="add">
                                                    <Button
                                                        type="submit"
                                                        bsStyle="primary"
                                                        label="global.accept"
                                                        disabled={disabled}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Grid>
                                </Form>
                            );
                        }}
                    </Formik>
                </MainContainer>
            </PageLoading>
        );
    }
}
const mapStateToProps = (state) => ({
    fetching: investmentfundsSelectors.getFetching(state),
    accountData: investmentfundsSelectors.getAccountData(state),
});
export default connect(mapStateToProps)(SwornDeclaration);
